<template>
  <div id="app">
    <!-- header -->
    <Header></Header>
    <router-view/>
    <!-- footer -->
    <Footer></Footer>

  </div>
</template>

<script>
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";


export default {
  name : 'App',
  metaInfo: {
    title: 'Brian Tam Portfolio',
  },
  components :{
    Header,
    Footer
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.hover-pointer{
  cursor: pointer;
}

.transition{
  transition: 5s;
}
</style>
